import { setShowModalAction } from "@3gaam/capp/src/store/general";
import { useAppDispatch } from "@3gaam/capp/src/store/hooks";
import { localStorageGet } from "@3gaam/shared/utils/localStorage";
import { useEffect } from "react";

export const useCheckVersion = () => {
  let dispatch = useAppDispatch();

  useEffect(() => {
    let interval: NodeJS.Timer | undefined;
    interval = setInterval(() => {
      let now = Date.now();
      let versionManager = localStorageGet("version-manager-c");
      if (!versionManager) return;
      if (now - versionManager.closedAt > 24 * 3600 * 1000) {
        // should show modal again
        dispatch(
          setShowModalAction("updateModal", true, {
            ignorable: true,
            message: '"نسخه جدید نرم‌افزار منتشر شده"',
          }),
        );
      }
    }, 3600 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);
};
